import {
  ContentChildren,
  Directive,
  Input,
  QueryList,
  TemplateRef,
} from "@angular/core";
import { TabGroupPanelContext } from "@app/models/tab-group-panel/tab-group-panel";
import { TabContentPanelDirective } from "@app/directives/tab-group-panel/tab-content-panel.directive";

@Directive({
  selector: "[appTabHeaderPanelTemplate]",
})
export class TabHeaderPanelDirective {
  @Input() hasCustomTemplate: boolean;

  @ContentChildren(TabHeaderPanelDirective)
  readonly tabsContentTemplates: QueryList<TabContentPanelDirective>;

  constructor(public templateRef: TemplateRef<TabGroupPanelContext>) {}
}
